export const resourcesConstants = {
    SETEXPERTSADVISORSEXPANDED_REQUEST: 'EXPERTSADVISORSEXPANDED_SETEXPERTSADVISORSEXPANDED_REQUEST',
    SETEXPERTSADVISORSEXPANDED_SUCCESS: 'EXPERTSADVISORSEXPANDED_SETEXPERTSADVISORSEXPANDED_SUCCESS',
    SETEXPERTSADVISORSEXPANDED_FAILURE: 'EXPERTSADVISORSEXPANDED_SETEXPERTSADVISORSEXPANDED_FAILURE',

    SETGRANTSEXPANDED_REQUEST: 'GRANTSEXPANDED_SETGRANTSEXPANDED_REQUEST',
    SETGRANTSEXPANDED_SUCCESS: 'GRANTSEXPANDED_SETGRANTSEXPANDED_SUCCESS',
    SETGRANTSEXPANDED_FAILURE: 'GRANTSEXPANDED_SETGRANTSEXPANDED_FAILURE',
};
